import styled from "@emotion/styled"
import { PinInputField } from "@chakra-ui/react"

export const StyledPinInputField = styled(PinInputField)`
  width: ${(props) => (props.width ? `${props.width}px` : "")};
  height: ${(props) => (props.height ? `${props.height}px` : "")};
`
